import { render, staticRenderFns } from "./TouchEvents.vue?vue&type=template&id=512ea7b1&scoped=true&"
import script from "./TouchEvents.vue?vue&type=script&lang=js&"
export * from "./TouchEvents.vue?vue&type=script&lang=js&"
import style0 from "./TouchEvents.vue?vue&type=style&index=0&id=512ea7b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ea7b1",
  null
  
)

export default component.exports